import { render, staticRenderFns } from "./PrimeiraPropaganda.vue?vue&type=template&id=74a8796b&"
import script from "./PrimeiraPropaganda.vue?vue&type=script&lang=js&"
export * from "./PrimeiraPropaganda.vue?vue&type=script&lang=js&"
import style0 from "./PrimeiraPropaganda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports